import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

export type InputTypes =
  | 'text'
  | 'search'
  | 'email'
  | 'password';

@Component({
  selector: 'cp-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.less']
})
export class InputComponent implements OnInit {
  @Input()
  type: InputTypes;

  @Input()
  inputId = '';

  @Input()
  cpFormControl = new UntypedFormControl();

  @Input()
  showErrors = true;

  @Input()
  label?: string;

  @Input()
  large?: boolean;

  @Input()
  inputClass = '';

  @Input()
  explicitError?: string;

  @Input()
  placeholder = '';

  @Input()
  disabled = false;

  @Input()
  grow?: boolean;

  @Input()
  search?: boolean;

  @Input()
  errorClass?: string;

  @Input()
  validate = true;

  @Input()
  get cpModel() {
    return this.cpModelValue;
  }

  @Output()
  cpModelChange = new EventEmitter<string | undefined>();

  set cpModel(value: string | undefined) {
    this.cpModelValue = value;
    this.cpModelChange.emit(value);
  }

  get mergedInputClass() {
    return { 'mod-search icon-search': this.search, 'mod-error': this.validate };
  }

  private cpModelValue: string | undefined;

  ngOnInit() {
    if (this.disabled) {
      this.cpFormControl.disable();
    }
  }
}
